$(document).ready(function() {
    var win = $(window); 
    var target = window.location.hash;

    
    if ( target != '' ){
        var $target = jQuery(target); 
        var check = 'ig';
        if (target.indexOf(check) !== -1) {
          //$('.nav-tabs a[href="' + target + '"]').tab('show'
          $(target).collapse('toggle');
          
          jQuery('html, body').stop().animate({
          'scrollTop': $target.offset().top - 160}, // set offset value here i.e. 50
          700, 
          'swing',function () {
          //window.location.hash = target - 60 ;
          });
        }
        
    }
  
  

  
  	$('.pflegekonzeptctahover').on("mouseenter", function() {
        var hovercall = $(this).attr('data-ctahover');
      	$(".conecpt-information").find(".pflegekonzepthitem[data-hover*='" + hovercall + "']").css('font-family','Zurich W01 Bold');
    }).on("mouseleave", function() {
        var hovercall = $(this).attr('data-ctahover');
      	$(".conecpt-information").find(".pflegekonzepthitem[data-hover*='" + hovercall + "']").css('font-family','Zurich W01 Light');
    });
  
  	/*$( ".lex-item .btn" ).each(function( index ) {
      console.log( $(this).attr('data-target') + " : " + $( this ).text() );
    });*/
  
});

smoothAnchorScroll();

/* ****************************
 *** Scroll
 **************************** */
function smoothAnchorScroll() {
    $('a.anchor-link').click(function (event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function () {
                    var $target = $(target);
                    $target.focus();

                    if ($target.is(":focus")) {
                        return false;
                    } else {
                        $target.attr('tabindex', '-1');
                        $target.focus();
                        if($('#menu').hasClass('open')){
                            toggleMenu();
                        }
                    }
                });
            }
        }
    });
}

if(!$('#header-slide-container.normal-content').length > 0) {
    
  /*$( "#logo" ).click(function() {
        if ($('#header-slide-container').hasClass('slider-big')) {
            $('#header-slide-container').animate({height:280},680, function()
            {
                $('#header-slide-container').removeClass('slider-big');
                $('#header-slide-container').addClass('slider-small');
            });
        }else{
            $('#header-slide-container').animate({height:680},680, function()
            {
                $('#header-slide-container').removeClass('slider-small');
                $('#header-slide-container').addClass('slider-big');
            });
        }
    });*/
  
}

if($('.product-single-detail-content-infobutton').length > 0) {
    $('.product-single-detail-content-infobutton').click(function(event){
        var button = $(event.target).is('.product-single-detail-content-infobutton') ? true : $(event.target).closest('.product-single-detail-content-infobutton');

        if($('.product-single-detail-content-infobutton-popup[data-popup-id="' + button.data('button-id') + '"]').hasClass('open')) {
            $('.product-single-detail-content-infobutton').removeClass('open');
            $('.product-single-detail-content-infobutton-popup').removeClass('open');
        } else {
            $('.product-single-detail-content-infobutton').removeClass('open');
            $('.product-single-detail-content-infobutton-popup').removeClass('open');

            button.addClass('open');
            $('.product-single-detail-content-infobutton-popup[data-popup-id="' + button.data('button-id') + '"]').addClass('open');
        }
    });

    $(document).click(function(event){
    });
}

var mobileMenuBreakpoint = window.matchMedia('(max-width: 1199.98px)');

$('#burger-icon').click(openMenu);

$('.site-menu__toggle').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();

    var toggle = $(this);
    var menuItem = toggle.closest('.site-menu__item--has-children');
    var shouldOpen = !menuItem.hasClass('is-open');

    closeMenuDropdowns(menuItem);

    menuItem.toggleClass('is-open', shouldOpen);
    toggle.attr('aria-expanded', shouldOpen ? 'true' : 'false');
});

$('.site-menu__item--has-children').on('mouseenter focusin', function() {
    if (!mobileMenuBreakpoint.matches) {
        closeMenuDropdowns($(this));
    }
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.menu-wrapper').length) {
        closeMenuDropdowns();
    }
});

$(document).on('keyup', function(event) {
    if (event.key === 'Escape') {
        closeMenuDropdowns();
        closeMobileMenu();
    }
});

$(window).on('resize', function() {
    if (!mobileMenuBreakpoint.matches) {
        closeMobileMenu();
    }

    closeMenuDropdowns();
});

function closeMenuDropdowns(exception) {
    $('.site-menu__item--has-children').each(function() {
        var item = $(this);

        if (exception && item.is(exception)) {
            return;
        }

        item.removeClass('is-open');
        item.find('> .site-menu__item-inner > .site-menu__toggle').attr('aria-expanded', 'false');
    });
}

function closeMobileMenu() {
    $('#burger-icon').removeClass('open');

    if($('.menu-wrapper').hasClass('open')) {
        $('.menu-wrapper').removeClass('open');
        setTimeout(function(){
            $('.menu-wrapper').removeClass('open-block');
        }, 351);
    } else {
        $('.menu-wrapper').removeClass('open-block');
    }
}

function openMenu() {
    $('#burger-icon').toggleClass('open');

    if($('.menu-wrapper').hasClass('open')) {
        closeMenuDropdowns();
        $('.menu-wrapper').removeClass('open');
        setTimeout(function(){
            $('.menu-wrapper').removeClass('open-block');
        }, 351);
    } else {
        $('.menu-wrapper').addClass('open-block');
        setTimeout(function(){
            $('.menu-wrapper').addClass('open');
        }, 1);
    }
}



$( "#lbh_home" ).on( "click", function(event) {
  $('#lbh_home').hide();
});



$( ".addToCartBtn" ).on( "click", function(event) {
  event.preventDefault();
  //data-addtocartname
  //data-addtocartid
  var quantity = 1;
  var productname = $(this).attr('data-addtocartname');
  var productid = $(this).attr('data-addtocartid');
  $('#addedToCartModal').attr('data-cart-add-pending', 'true');
  
  jQuery.post('/cart/add.js', {
    quantity: quantity,
    id: productid
  }).done(function() {
    $('#addedToCartModal').attr('data-cart-add-pending', 'false').attr('data-cart-add-success', 'true');
    $('#addedToCartModal [data-cart-feedback-message]').text(productname + ' wurde erfolgreich dem Warenkorb hinzugefügt.');
    $('#addedToCartModal').modal('show');
    jQuery.getJSON('/cart.js', function(cart) {
      $('.headcartnav-count').text('(' + cart.item_count + ')');
    });
  }).fail(function() {
    $('#addedToCartModal').attr('data-cart-add-pending', 'false').attr('data-cart-add-success', 'false');
    $('#addedToCartModal [data-cart-feedback-message]').text('Das Produkt konnte nicht zum Warenkorb hinzugefügt werden. Bitte versuchen Sie es erneut.');
    $('#october-campaign-cart-summary').prop('hidden', true);
    $('#addedToCartModal').modal('show');
  });
});
